import React, { useContext, useState } from "react";
import LeftPanel from "../../../components/LeftPanel";
import Header from "../../../components/Header";
import axios from "axios";
import DatePicker from "react-datepicker";
import { Search } from "@mui/icons-material";
import Context from "../../../context/context";
import JsPDF from 'jspdf';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const OrderTaxReport = () => {
    const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
    const [startDate, setStartDate] = useState((new Date(Date.UTC(new Date(parseFloat(localStorage.getItem("current-working-day")))?.getFullYear().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getMonth().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getDate().toString(), '00', '00', '00'))).getTime())
    const [endDate, setEndDate] = useState((new Date(Date.UTC(new Date(parseFloat(localStorage.getItem("current-working-day")))?.getFullYear().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getMonth().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getDate().toString(), '00', '00', '00'))).getTime())
    const [itemsDetails, setItemsDetails] = useState([])
    const context = useContext(Context);
    const { setUnAuthPopup } = context;
    let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || []
    let date_formate = sessionStorage.getItem("date_format")

    const onSearch = async () => {
        let timeDifference = (new Date(parseFloat(localStorage.getItem("current-working-day")))).getDate()
            - (new Date(startDate)).getDate()
        // console.log((parseInt(restrictions[0]?.other_report_Daily_summary) || 0) , timeDifference)
        if (restrictions.length && (parseInt(restrictions[0]?.other_report_item_sale) || 0) < timeDifference) {
            setUnAuthPopup(true)
            setTimeout(() => setUnAuthPopup(false), 3000)
            return
        }
        const result = await axios({
            url: "https://api.myfooddo.com/order/getTexReport",
            // url: "http://localhost:5000/order/getTexReport",
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data: [{
                start_date: startDate,
                end_date: endDate,
                outlet_uuid: localStorage.getItem("outlet_uuid"),
            }]
        })

        console.log(result.data.result)
        setItemsDetails(result.data.result)
    }

    const printDocument = () => {
        const report = new JsPDF('landscape', 'pt', "a4");
        report.html(document.getElementById('xlsTableToPrint')).then(() => {
            report.save('report.pdf');
        });
    }

    return (
        <>
            <LeftPanel
                setIsItemAvilableOpen={setIsItemAvilableOpen}
                isItemAvilableOpen={isItemAvilableOpen}
            />
            <Header />
            <div className="customer-reports-container orders-report-container" style={{ marginLeft: "10px", height: 'calc(100vh - 50px)' }}>
                <div id="heading">
                    <h2>Sales GST</h2>
                </div>
                <div style={{ display: "flex", width: "600px", alignItems: "center", justifyContent: "space-between", padding: "10px" }}>
                    <div
                        style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label htmlFor="date-from" style={{ width: "50%", }}>From date</label>
                        <DatePicker
                            id="date-from"
                            selected={startDate}
                            dateFormat={sessionStorage.getItem("date_format").replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={(date) => {
                                setStartDate((new Date(Date.UTC(new Date(date)?.getFullYear().toString(), new Date(date)?.getMonth().toString(), new Date(date)?.getDate().toString(), '00', '00', '00'))).getTime())
                            }}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}

                        />
                    </div>
                    <div
                        style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label style={{ width: "40%", }}>To date</label>
                        <DatePicker
                            id="date-to"
                            selected={endDate}
                            dateFormat={sessionStorage.getItem("date_format").replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={(date) => {
                                setEndDate((new Date(Date.UTC(new Date(date)?.getFullYear().toString(), new Date(date)?.getMonth().toString(), new Date(date)?.getDate().toString(), '00', '00', '00'))).getTime())
                            }}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}

                        />
                    </div>
                    <div
                        style={{ display: "flex", alignItems: "center", height: "100%", justifyContent: "left", flexDirection: "column" }}
                    >
                        <button
                            style={{
                                border: "none",
                                padding: "10px 20px",
                                fontWeight: "bold",
                                color: "white",
                                backgroundColor: "black",
                                cursor: "pointer",
                                marginTop: "25px"
                            }}
                            onClick={onSearch}
                        >
                            <Search style={{ fontSize: "12px" }} /> Search
                        </button>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "absolute", width: "60px", right: "10vw", top: "50px" }}>
                        {/* <div className="hoverIcons" onClick={downloadXLSHandler} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer", }}>
              <BackupTableOutlined style={{ fontSize: "30px" }} />
              Export Xls
            </div> */}
                        <ReactHTMLTableToExcel
                            className="hoverIcons"
                            style={{ cursor: "pointer", }}
                            table="xlsTableToPrint"
                            sheet="Sheet"
                            filename="orders-report"
                            buttonText="Excel"
                        />
                        <button className="hoverIcons" onClick={printDocument} style={{ cursor: "pointer" }}>
                            {/* <PictureAsPdf style={{ fontSize: "30px" }} /> */}
                            PDF
                        </button>

                    </div>
                </div>
                <div
                    className="customer-reports-container table-container-user"
                >
                    <Table itemsDetails={itemsDetails?.tax_data} total={itemsDetails?.total} />
                </div>
            </div>
            <div style={{ display: "none" }}>

                <table id='xlsTableToPrint'>
                    <thead id="tableHeadToPrint">
                        <tr><th colSpan={9} style={{ fontSize: "x-large" }}>{localStorage.getItem("outlet-name")}</th></tr>
                        <tr>
                            <th colSpan={4}>From : {sessionStorage.getItem("date_format")
                                ?.replace(
                                    "mm",
                                    ("00" + ((new Date(startDate))?.getMonth() + 1)?.toString())?.slice(-2)
                                )
                                ?.replace(
                                    "yy",
                                    ("0000" + (new Date(startDate))?.getFullYear()?.toString())?.slice(-4)
                                )
                                ?.replace(
                                    "dd",
                                    ("00" + (new Date(startDate))?.getDate()?.toString())?.slice(-2)
                                )}</th>
                            <th></th>
                            <th colSpan={4}>To :{sessionStorage.getItem("date_format")
                                ?.replace(
                                    "mm",
                                    ("00" + ((new Date(endDate))?.getMonth() + 1)?.toString())?.slice(-2)
                                )
                                ?.replace(
                                    "yy",
                                    ("0000" + (new Date(endDate))?.getFullYear()?.toString())?.slice(-4)
                                )
                                ?.replace(
                                    "dd",
                                    ("00" + (new Date(endDate))?.getDate()?.toString())?.slice(-2)
                                )}</th>
                        </tr>
                        <tr>
                            <th>S.N</th>
                            <th>Party Name</th>
                            <th>Invoice No.</th>
                            <th>Invoice Date</th>
                            <th>Amt</th>
                            <th>Tax Rate</th>
                            <th>Taxable Value</th>
                            <th>CGST(RS)</th>
                            <th>SGST(RS)</th>
                        </tr>
                    </thead>
                    <tbody id="tableBodyToPrint" style={{ border: " solid black" }}>
                        {itemsDetails?.tax_data?.map((item, i) =>

                            <tr key={Math.random()}>
                                <td>{i + 1}</td>
                                <td>{item?.party_name}</td>
                                <td>{item.invoice_no}</td>
                                <td>{date_formate.replace(
                                    "mm",
                                    (
                                        "00" +
                                        (
                                            new Date(parseInt(item.invoice_date))?.getMonth() + 1
                                        ).toString()
                                    ).slice(-2)
                                )
                                    .replace(
                                        "yy",
                                        (
                                            "0000" +
                                            new Date(parseInt(item.invoice_date))?.getFullYear().toString()
                                        ).slice(-4)
                                    )
                                    .replace(
                                        "dd",
                                        (
                                            "00" +
                                            new Date(parseInt(item.invoice_date)).getDate().toString()
                                        ).slice(-2)
                                    )

                                }</td>
                                <td>{item.amt}</td>
                                <td>{item.tax_rate}</td>
                                <td>{item.taxable_value}</td>
                                <td>{item.cgst}</td>
                                <td>{item.sgst}</td>
                            </tr>
                        )}
                        <tr style={{ fontWeight: "bold" }}>
                            <td>{itemsDetails?.total?.party_name}</td>
                            <td>{itemsDetails?.total?.invoice_no}</td>
                            <td></td>
                            <td>{itemsDetails?.total?.invoice_date}</td>
                            <td>{itemsDetails?.total?.amt}</td>
                            <td>{itemsDetails?.total?.tax_rate}</td>
                            <td>{itemsDetails?.total?.taxable_value}</td>
                            <td>{itemsDetails?.tax_data?.length > 1 ? itemsDetails?.tax_data?.map(a => a.cgst).reduce((a, b) => parseFloat(a) + parseFloat(b))?.toFixed(3) : itemsDetails?.tax_data?.length ? itemsDetails?.tax_data[0]?.cgst : 0}</td>
                            <td>{itemsDetails?.tax_data?.length > 1 ? itemsDetails?.tax_data?.map(a => a.sgst).reduce((a, b) => parseFloat(a) + parseFloat(b))?.toFixed(3) : itemsDetails?.tax_data?.length ? itemsDetails?.tax_data[0]?.sgst : 0}</td>
                        </tr>
                        <tr><td colSpan={9}></td></tr>
                        <tr><td colSpan={9}>Generated using FoodDo at {
                            sessionStorage.getItem("date_format")
                                ?.replace(
                                    "mm",
                                    ("00" + ((new Date())?.getMonth() + 1)?.toString())?.slice(-2)
                                )
                                ?.replace(
                                    "yy",
                                    ("0000" + (new Date())?.getFullYear()?.toString())?.slice(-4)
                                )
                                ?.replace(
                                    "dd",
                                    ("00" + (new Date())?.getDate()?.toString())?.slice(-2)
                                )}{" "}{(new Date()).toLocaleTimeString(navigator.language, {
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}</td></tr>
                    </tbody>
                </table>


            </div>
        </>
    )
}

export default OrderTaxReport
function Table({ itemsDetails, total }) {
    let date_formate = sessionStorage.getItem("date_format")
    return (

        <table className="user-table" style={{ overflow: "auto" }}>
            <thead>
                <tr>
                    <th>S.N</th>
                    <th>Party Name</th>
                    <th>Invoice No.</th>
                    <th>Invoice Date</th>
                    <th>Amt</th>
                    <th>Tax Rate</th>
                    <th>Taxable Value</th>
                    <th>CGST(RS)</th>
                    <th>SGST(RS)</th>
                </tr>
            </thead>
            <tbody>
                {itemsDetails?.map((item, i) =>

                    <tr key={Math.random()}>
                        <td>{i + 1}</td>
                        <td>{item?.party_name}</td>
                        <td>{item.invoice_no}</td>
                        <td>{date_formate.replace(
                            "mm",
                            (
                                "00" +
                                (
                                    new Date(parseInt(item.invoice_date))?.getMonth() + 1
                                ).toString()
                            ).slice(-2)
                        )
                            .replace(
                                "yy",
                                (
                                    "0000" +
                                    new Date(parseInt(item.invoice_date))?.getFullYear().toString()
                                ).slice(-4)
                            )
                            .replace(
                                "dd",
                                (
                                    "00" +
                                    new Date(parseInt(item.invoice_date)).getDate().toString()
                                ).slice(-2)
                            )

                        }</td>
                        <td>{item.amt}</td>
                        <td>{item.tax_rate}</td>
                        <td>{item.taxable_value}</td>
                        <td>{item.cgst}</td>
                        <td>{item.sgst}</td>
                    </tr>
                )}
                <tr style={{ fontWeight: "bold" }}>
                    <td>{total?.party_name}</td>
                    <td></td>
                    <td>{total?.invoice_no}</td>
                    <td>{total?.invoice_date}</td>
                    <td>{total?.amt}</td>
                    <td>{total?.tax_rate}</td>
                    <td>{total?.taxable_value}</td>
                    <td>{itemsDetails?.length > 1 ? itemsDetails?.map(a => a.cgst).reduce((a, b) => parseFloat(a) + parseFloat(b))?.toFixed(3) : itemsDetails?.length ? itemsDetails[0]?.cgst : 0}</td>
                    <td>{itemsDetails?.length > 1 ? itemsDetails?.map(a => a.sgst).reduce((a, b) => parseFloat(a) + parseFloat(b))?.toFixed(3) : itemsDetails?.length ? itemsDetails[0]?.sgst : 0}</td>
                </tr>
            </tbody>
        </table>
    );
}